import PropTypes from "prop-types";
import { isNil, isEmpty } from "ramda";
import { Typography } from "@mui/material";

import { DEFAULT_INVITE_DETAILS, DEFAULT_INVITE_THEME } from "enums";
import InvitePresenter from "presenters/InvitePresenter";
import ThemePresenter from "presenters/ThemePresenter";
import GuestPresenter from "presenters/GuestPresenter";

import { Title, GuestListContainer, GuestList as GuestListStyled } from "./styles";

const GuestList = ({ invite = DEFAULT_INVITE_DETAILS, theme = DEFAULT_INVITE_THEME, isGuestView }) => {
  const guests = isGuestView ? InvitePresenter.attendingGuests(invite) : InvitePresenter.guests(invite);
  const canSeeGuestList = InvitePresenter.canSeeGuestList(invite);
  const hide = isNil(guests) || isEmpty(guests) || !canSeeGuestList;

  if (hide) return null;

  return (
    <GuestListContainer
      data-testid="guestListContainer"
      inviteTheme={theme}
      container
      direction="column"
      justifySelf="center"
      alignItems="center"
    >
      <Title data-testid="guestListTitle" className="guestListTitle" variant="large">
        Guest List
      </Title>
      <GuestListStyled
        textAlign="center"
        display="grid"
        gridTemplateColumns={{ mobile: "repeat(2, 1fr)", tablet: "repeat(3, 1fr)" }}
        rowGap={5}
        columnGap={15}
      >
        {guests.map((guest) => (
          <Typography className="guestList" variant="large" key={GuestPresenter.id(guest)}>
            {GuestPresenter.name(guest)}
          </Typography>
        ))}
      </GuestListStyled>
    </GuestListContainer>
  );
};

GuestList.propTypes = {
  invite: InvitePresenter.shape(),
  theme: ThemePresenter.shape(),
  isGuestView: PropTypes.bool,
};

export default GuestList;
